import React from 'react';
import { Page } from 'react-onsenui';
import PropTypes from 'prop-types';

const Layouts = props => {
    const modifier = props.modifier ? `material ${props.modifier}` : 'material'
    return (
        <Page
            renderToolbar={props.toolbar}
            renderFixed={props.fab}
            renderBottomToolbar={props.footer}
            modifier={modifier}
            renderModal={props.modal}
        >
         {props.children}
        </Page>
    )
}

Layouts.propTypes = {
    modifier: PropTypes.string,
    toolbar: PropTypes.func.isRequired,
    fab: PropTypes.func,
    footer: PropTypes.func,
    modal: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired
}

export default Layouts;